import { RoutePermittedRole } from 'constants/AppConst';
import { ROUTE_STRING } from 'constants/RouteString';
import List from './List';
import Detail from './Detail';
import Add from './Add';
import UpgradeVersion from './UpgradeVersion';
import ViewLog from './ViewLog';
import { AuthorizePermission } from '@tenant/utility/constants/authorizePermission';
import AllowedAccess from '@tenant/core/AppPermission/AllowedAccess';

export const dockerImageRoutes = [
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.DOCKER_IMAGE.LIST],
    element: (
      <AllowedAccess permissionIds={[AuthorizePermission.REPOSITORY_READ]}>
        <List />
      </AllowedAccess>
    ),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.DOCKER_IMAGE.VIEW],
    element: (
      <AllowedAccess permissionIds={[AuthorizePermission.REPOSITORY_READ]}>
        <Detail />
      </AllowedAccess>
    ),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.DOCKER_IMAGE.ADD],
    element: (
      <AllowedAccess permissionIds={[AuthorizePermission.REPOSITORY_CREATE]}>
        <Add />
      </AllowedAccess>
    ),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.DOCKER_IMAGE.UPGRADE_VERSION],
    element: (
      <AllowedAccess permissionIds={[AuthorizePermission.REPOSITORY_DEPLOY]}>
        <UpgradeVersion />
      </AllowedAccess>
    ),
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: [ROUTE_STRING.DOCKER_IMAGE.LOG],
    element: <ViewLog />,
  },
];
